import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import { on } from '@ember/modifier';

interface Signature {
  Args: {
    changeset: EmberChangeset;
    isMessagingRestricted: boolean;
  };
}

const messageContentKey = 'messageContent';

export default class ChatInputComponent extends Component<Signature> {
  onInputChange = event => {
    const message = event.currentTarget.value;
    this.args.changeset.set(messageContentKey, message);
  };

  <template>
    <div class='ui form'>
      <textarea
        aria-label='Votre message'
        value={{changesetGet @changeset 'messageContent'}}
        {{! On small screens, the height is the one of 3 rows: 3 × the FUI textarea line-height (1.2857em), plus its padding and border }}
        class='ui input max-sm:[.ui.form_textarea&]:h-[calc(5.43em+2px)]
          {{if
            @isMessagingRestricted
            "[.ui.form_&textarea]:text-[#808080] [.ui.form_&textarea]:opacity-100 [.ui.form_&textarea]:[-webkit-text-fill-color:#808080]"
          }}'
        rows='5'
        data-test-chat='input'
        disabled={{@isMessagingRestricted}}
        {{on 'input' this.onInputChange}}
      >
      </textarea>
    </div>
  </template>
}
